import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

export default function ContactPage() {
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");
    const formData = new FormData(event.target);

    formData.append("access_key", "79ee9b3c-33b2-465e-9ef3-b9e73565cbf3");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form submitted successfully!");
      event.target.reset();
    } else {
      console.error("Error:", data);
      setResult(data.message || "Something went wrong.");
    }
  };

  return (
    <main className="bg-white text-gray-800">
      <Helmet>
        <meta
          name="description"
          content="Get in touch with Codexa. We'd love to hear from you regarding your ideas, questions, or project collaboration."
        />
      </Helmet>

      {/* Contact Form Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-gray-50 p-8 rounded-2xl shadow-xl space-y-8"
        >
          <div className="text-center space-y-2">
            <h2 className="text-3xl font-bold text-indigo-600">Contact Us</h2>
            <p className="text-gray-600">We usually respond within 24 hours.</p>
          </div>

          <form className="grid md:grid-cols-2 gap-6" onSubmit={onSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Your full name"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                  required
                />
              </div>
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700">Message</label>
              <textarea
                name="message"
                placeholder="Write your message here..."
                rows="5"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                required
              ></textarea>
            </div>

            <div className="md:col-span-2 text-center">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                type="submit"
                className="bg-indigo-600 text-white px-8 py-3 rounded-lg text-lg font-medium shadow-lg hover:bg-indigo-700 transition"
              >
                Send Message
              </motion.button>
              
              <p className="mt-4 text-sm text-gray-600">{result}</p>
            </div>
            
          </form>
        </motion.div>
        
      </section>

      {/* Contact Info */}
      <section className="py-16 bg-gray-100">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto px-6 grid md:grid-cols-3 gap-10 text-center"
        >
          <div>
            <h3 className="text-lg font-semibold text-indigo-600">Email</h3>
            <a href="mailto:thecodexaoffical@gmail.com" className="text-gray-700">
              thecodexaoffical@gmail.com
            </a>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-indigo-600">Phone</h3>
            <p className="text-gray-700">Phone: +923254472055</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-indigo-600">Location</h3>
            <p className="text-gray-700">Remote | Global Team</p>
          </div>
        </motion.div>
      </section>
    </main>
  );
}
